import React from 'react';
const HealthCheck: React.FC = () => {
    return <h3>Hey There!!! The App is Healthy</h3>;
};

export default HealthCheck;
